module.exports = __webpack_public_path__ + "static/media/mail.4f81c435.svg";